// src/main.js
import './assets/main.css'
import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import * as Sentry from '@sentry/vue'
import { usePocketAuthStore } from '@/stores/usePocketAuthStore'

const app = createApp(App)
const head = createHead()

// Sentry
Sentry.init({
  app,
  dsn: 'https://6db1ab7e22667a9019e82d5f0a1fc687@o4508687543500800.ingest.de.sentry.io/4509401217957968',
  integrations: [],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  release: import.meta.env.VITE_RELEASE,
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
})

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(head)

const auth = usePocketAuthStore()
auth.tryAutoLogin()

app.mount('#app')
